export const GET_TENDER_MENUS = 'get_tender_menus';
export const TENDER_MENU_LOADED = 'tender_menu_loaded';
export const SAVE_TENDER_MENU = 'save_tender_menu';
export const UPDATE_TENDER_MENU = 'update_tender_menu';
export const DELETE_TENDER_MENU = 'delete_tender_menu';
export const ERROR_DATA = 'error_data';
export const RESET_TENDER_MENU = 'reset_tender_menu';
export const SYNCING = 'syncing';
